/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Totp_Unenrolled_SuccessInputs */

const fr_totp_unenrolled_success = /** @type {(inputs: Totp_Unenrolled_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'authentification à deux facteurs a été désactivée`)
};

/**

* @param {Totp_Unenrolled_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const totp_unenrolled_success = /** @type {((inputs?: Totp_Unenrolled_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Totp_Unenrolled_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_totp_unenrolled_success(inputs)
});